import { schema } from 'normalizr';

const activityCategoryTypes = new schema.Entity('activityCategoryTypes', {});

export default activityCategoryTypes;
